<template>
  <div class="user-manage">
    <el-form inline>
      <el-form-item label="用户名：">
        <el-input v-model="params.loginName" @change="searchData" style="width: 120px" clearable placeholder="用户名"></el-input>
      </el-form-item>
      <el-form-item label="姓名：">
        <el-input v-model="params.name" @change="searchData" style="width: 120px" clearable placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item label="性别：">
        <el-select v-model="params.sex" @change="searchData" clearable style="width: 120px" placeholder="性别">
          <el-option value="男" label="男"></el-option>
          <el-option value="女" label="女"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="实名状态：">
        <el-select v-model="params.isReal" @change="searchData" clearable style="width: 120px" placeholder="是否实名">
          <el-option :value="1" label="是"></el-option>
          <el-option :value="0" label="否"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="params.query" clearable placeholder="用户名、姓名、身份证号、手机号" style="width: 255px;"
          @change="searchData"></el-input>  
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchData" icon="search">搜索</el-button>  
      </el-form-item> 
    </el-form>

    <el-table :data="users" tooltip-effect="dark" border stripe v-loading="loading" :height="tableHeight.height">
      <el-table-column v-for="(column, index) in tableColumns" :key="index" :type="column.type" :prop="column.prop"
        :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
        :fixed="column.fixed" :show-overflow-tooltip="column.tooltip">
      </el-table-column>

      <el-table-column label="操作" width="80" fixed="right">
        <template #="{row}">
          <el-button type="text" @click="toInfo(row.id)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
      :current-page="params.pageNo" :page-size="params.length" @current-change="pageNoChange"
      @size-change="lengthChange">
    </el-pagination>
  </div>

</template>

<script>
import { defineComponent, ref } from 'vue';
import { getUserList } from '@/api/sys/user';

export default defineComponent({
  data() {
    return {
      tableHeight: { height: ref('')},
      loading: false,
      users: [],
      total: 0,
      tableColumns: [
        { type: 'index', width: 55, label: '序号', fixed: 'left' },
        { prop: 'loginName', label: '用户名', minWidth: 120, fixed: 'left', tooltip: true },
        { prop: 'name', label: '姓名', minWidth: 100, fixed: 'left', tooltip: true },
        { prop: 'sex', label: '性别', minWidth: 60 },
        { prop: 'age', label: '年龄', minWidth: 60 },
        { prop: 'wechatId', label: '微信Id', minWidth: 120, tooltip: true },
        { prop: 'phone', label: '电话', minWidth: 130 },
        { prop: 'idCardNo', label: '身份证号', width: 180 },
        { prop: 'isReal', label: '实名状态', width: 120, formatter: (row, column, val) => val === 1 ? '已实名' : '未实名' }
      ],
      params: {
        loginName: null,
        name: null,
        sex: null,
        isReal: null,
        query: null,
        pageNo: 1,
        length: 20
      }
    }
  },
  methods: {
    getData() {
      this.loading = true;
      getUserList(this.params).then(({data}) => {
        this.users = data.data;
        this.total = data.page.totalRecords;
        this.loading = false;
      }).catch(_ => this.loading = false);
    },
    searchData() {
      this.params.pageNo = 1;
      this.getData();
    },
    pageNoChange(pageNo) {
      this.params.pageNo = pageNo;
      this.getData();
    },
    lengthChange(length) {
      this.params.length = length;
      this.searchData();
    },
    toInfo(id) {
      this.$router.push(`/sys/user/info?id=${id}`)
    },
    getHeight() {
      let width = document.documentElement.clientWidth;
      let height;
      if (width >= 1560) {
        height = 225;
      } else if (width >= 926) {
        height = 275;
      } else {
        height = 325;
      }
      this.tableHeight.height = `calc(100vh - ${height}px)`;
    }
  },
  created() {
    this.getHeight();
    this.getData();
    window.addEventListener('resize', this.getHeight)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.getHeight)
  }
})
</script>

<style lang="scss" scoped>
.user-manage {
  padding: 20px;
  .el-table {
    margin-bottom: 15px;
  }
}
</style>